import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";

export default function ListHeader({
    currentList,
    joinedBanner,
    assignedRecipient,
    isMember,
    isAdmin,
    onEditList,
    onDeleteList,
    onInviteUser,
    onAddItem,
    variant = "default",
}) {
    if (!currentList) return null;

    return (
        <div className="fixed top-0 pt-[80px] left-0 right-0 px-6 bg-white z-20 border-b border-surface">
            {joinedBanner && (
                <div className="bg-primary text-secondary opacity-70 p-2 mb-4 rounded">
                    You've joined {currentList.name}!
                </div>
            )}

            <Breadcrumbs className="max-w-3xl mx-auto" listName={currentList.name} />

            {variant === "secretSanta" ? (
                <>
                    <div className="max-w-3xl mx-auto px-6 md:px-0 flex gap-4 items-center">
                        <h1 className="text-xl font-bold">{currentList.name}</h1>
                        <span className="text-sm text-red-600 px-2 py-1 border border-red-200 rounded">
                            Secret Santa
                        </span>
                    </div>
                    <div className="max-w-3xl mx-auto px-6 md:px-0 flex justify-between items-center">
                        {isMember && assignedRecipient && (
                            <div className="flex items-center gap-2">
                                <div>
                                    You're Gifting: <strong>{assignedRecipient.name}</strong>
                                </div>
                                <Button
                                    variant="ghost"
                                    onClick={() =>
                                        window.open(`/public-list/${currentList.id}`, "_blank", "noopener,noreferrer")
                                    }
                                >
                                    View Public List
                                </Button>
                            </div>
                        )}

                        {isAdmin && (
                            <div className="flex gap-2">
                                <Button variant="icon" onClick={() => onEditList(currentList)}>
                                    <Icon icon="edit" />
                                </Button>
                                <Button variant="icon" onClick={onDeleteList}>
                                    <Icon icon="delete" />
                                </Button>
                                <Button variant="icon" onClick={onInviteUser}>
                                    <Icon icon="invite" />
                                </Button>
                            </div>
                        )}
                    </div>
                </>
            ) : (
                <div className="max-w-3xl mx-auto px-6 md:px-0 flex justify-between items-center">
                    <div className="flex gap-2 flex-start items-center">
                        <h1 className="text-xl font-bold">{currentList.name}</h1>
                        <Button
                            variant="ghost"
                            onClick={() =>
                                window.open(`/public-list/${currentList.id}`, "_blank", "noopener,noreferrer")
                            }
                        >
                            View Public List
                        </Button>
                    </div>

                    {isMember && (
                        <div className="flex gap-2 items-center">
                            {isAdmin && (
                                <>
                                    <Button variant="icon" onClick={() => onEditList(currentList)}>
                                        <Icon icon="edit" />
                                    </Button>
                                    <Button variant="icon" onClick={onDeleteList}>
                                        <Icon icon="delete" />
                                    </Button>
                                    <Button variant="icon" onClick={onInviteUser}>
                                        <Icon icon="invite" />
                                    </Button>
                                </>
                            )}
                        </div>
                    )}
                </div>
            )}

            {/* Wish List Title + Add New Item Button */}
            <div className="sticky top-[50px] bg-white z-30 border-surface py-3">
                <div className="max-w-3xl mx-auto px-6 md:px-0 flex justify-between items-center">
                    <h2 className="text-lg font-semibold">Your Wish List</h2>
                    {isMember && (
                        <Button variant="primary" onClick={onAddItem}>
                            Add New Item
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}
